export const getApiUrl = () =>
  process.env.NODE_ENV === "production"
    ? `${window.location.protocol}//${window.location.host}/${getBasePath()}`
    : `http://172.25.3.79:8090/${getBasePath()}`;

export const getBasePath = () => "sisrOrdinazioni";
